module.exports = __webpack_public_path__ + "img/arrow-right.2b3c0ec6.svg";